import { getPublicApi } from "../lib/axiosConfig";
import { PaymentConfirmation, PaymentError } from "../types/paymentStatus";
import { AppError } from "./classes";

const api = getPublicApi();

export const getPaymentConfirmation = async (totemId: string, date: string): Promise<PaymentConfirmation> => {
  try {
    const { data: PaymentConfirmation } = await api.get(`/cielo-transaction/confirmation/${totemId}?timestamp=${date}`);

    return PaymentConfirmation;
  } catch (error: any) {
    const errMsg = "Erro ao confirmacao de pagamento.";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

export const getPaymentError = async (totemId: string, date: string): Promise<PaymentError> => {
  try {
    const { data: PaymentError } = await api.get(`/cielo-transaction/error/${totemId}?timestamp=${date}`);

    return PaymentError;
  } catch (error: any) {
    const errMsg = "Erro ao confirmacao de pagamento.";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}